enum FilterTypes {
  DESTINATION = 'destination',
  DESTINATION_EXCURSIONS = 'destinationExcursions',
  PORT = 'port',
  PORT_EXCURSIONS = 'portExcursions',
  SHIP = 'ship',
  CABIN = 'cabin',
  CATEGORY = 'category',
  PORT_CODE = 'portCode',
  NUMBER_OF_NIGHTS = 'numberOfNights',
  TAG = 'tag',
  PROMOTION = 'promotion',
  FLY_AND_CRUISE = 'flyAndCruise',
  DATE = 'datefilter',
  GUEST = 'guestfilter',
  PRICE_RANGE = 'pricerange',
  MORE_FILTERS = 'morefilters',
  CRUISE_ID = 'cruiseId',
  PRICE_TYPE = 'priceType',
  PRICE_CODE = 'priceCode',
  PORT_OF_CALL = 'portOfCall',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  MIN_PRICE = 'minPrice',
  MAX_PRICE = 'maxPrice',
  ADULTS = 'adults',
  MINORS = 'minors',
  JUNIORS = 'juniors',
  FIRST_CABIN_ACCESSIBILITY = 'firstCabinAccessibility',
  SECOND_CABIN_ACCESSIBILITY = 'secondCabinAccessibility',
  CABIN2_ADULTS = 'cabin2Adults',
  CABIN2_MINORS = 'cabin2Minors',
  CABIN2_JUNIORS = 'cabin2Juniors',
  IS_CONNECTED_CABIN = 'isConnectedCabin',
  PAX_TYPE = 'paxType',
  AIRPORT = 'airport',
}

export { FilterTypes };
